module.exports = __webpack_public_path__ + "img/home-2.ba2f4c12.png";